import React from 'react';
import { DomainSearchSuiteModule } from '../../../../../../domainSearchSuite.module';
import { parseDomain } from '@wix/domains-serverless-interface';
import { Text, TextButton } from '@wix/design-system';
import { urls } from '../../../../../Navigation/urls';
export const OfacRestricted = _ref => {
  let domainName = _ref.domainName;
  const _parseDomain = parseDomain(domainName ?? ''),
    tld = _parseDomain.tld;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans,
    locale = _DomainSearchSuiteMod.locale;
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.restricted_domain",
    values: {
      tld
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    }), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      as: "a",
      href: urls.accountCountryLimitationSupportArticle(locale),
      onClick: () => {
        DomainSearchSuiteModule.internals.bi.onClickLink == null || DomainSearchSuiteModule.internals.bi.onClickLink({
          link: urls.accountCountryLimitationSupportArticle(locale)
        });
      },
      target: "_blank"
    })]
  }));
};
//# sourceMappingURL=OfacRestricted.js.map